import TestimonialPage from "../components/testimonial-page/testimonial-page";

export default function Testimonials() {
  return (
    <>
      <TestimonialPage />
    </>
  );
}
